import React, { Component } from 'react';

class CartProduct extends Component {

    state = {
        isMouseOver: false
    };

    handleMouseOver = () => {
        this.setState({ isMouseOver: true });
    };

    handleMouseOut = () => {
        this.setState({ isMouseOver: false });
    };

    render() {
        const { product } = this.props;

        const classes = ['shelf-item-gis'];

        if (!!this.state.isMouseOver) {
            classes.push('shelf-item--mouseover');
        }

        return (
            <div className={classes.join(' ')}>
                <div
                    className="shelf-item__del"
                    onMouseOver={() => this.handleMouseOver()}
                    onMouseOut={() => this.handleMouseOut()}
                    onClick={() => this.props.removeCartItem(product)}
                />
                <div className="shelf-item__details">
                    <p className="title">{product.BufferId.replace('_', ' ')}</p>
                    <p className="desc">
                        Total Area: {product.Area} km<sup>2</sup><br />
                        {/*Total Features: {product.Manhole + product.GravityMains + product.PressurizedMains + product.PublicSTP + product.NPSServiceArea}*/}
                    </p>
                </div>
                <div className="shelf-item__price">
                    <p>RM {product.Price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                </div>
            </div>
        );
    }
}

export default CartProduct;



// WEBPACK FOOTER //
// ./src/components/FloatCart/CartProduct.js